import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import entryService from './entryService';
import { getSupportedLocale, isStoreAgnosticPage } from '../utils';

/**
 * getContentfulPage
 * This function loads given page from contetnful
 * also, `language`, `store` and other router params could be provided.
 * It loads entity from contetnful by provided contentType from page config
 * and creates a Page instance, mapping contetnful data to Page internal representation.
 * @export
 * @param {*} Page
 * @param {string} language
 * @param {object} rest
 * @returns {Promise} promise with page instance in case of resolving
 */
export function getContentfulPage(Page, language, rest) {
    const { store, gType, gSlug } = rest;
    const filters = {
        ...Page.config.filters,
        locale: getSupportedLocale(language),
    };

    if (gType && gSlug && Page.config.contentType === contentTypes.CfGPage) {
        filters['fields.slug'] = gSlug;
        filters['fields.landingPageType'] = gType;
    }

    if (store && !isStoreAgnosticPage(Page.config.contentType)) {
        if (Page.config.contentType === contentTypes.CfHomePage) {
            filters['fields.store_code'] = store;
        } else {
            filters['fields.storeCode'] = store;
        }
    }

    return entryService
        .getCfEntry(Page.config.contentType, filters)
        .then((cfEntry) => new Page(Page.mapCfEntry(cfEntry)))
        .catch((error) => {
            throw error;
        });
}

export function getContentfulPageDiscount(Page, language, rest) {
    const { store, gType, gSlug } = rest;
    const filters = {
        ...Page.config.filters,
        locale: getSupportedLocale(language),
    };

    if (gType && gSlug && Page.config.contentType === contentTypes.CfGPage) {
        filters['fields.slug'] = gSlug;
        filters['fields.landingPageType'] = gType;
    }

    if (store && !isStoreAgnosticPage(Page.config.contentType)) {
        if (Page.config.contentType === contentTypes.CfHomePage) {
            filters['fields.store_code'] = store;
        } else {
            filters['fields.storeCode'] = store;
        }
    }

    return entryService.getCfEntry(Page.config.contentType, filters).then((cfEntry) => {
        if (cfEntry) {
            return new Page(Page.mapCfEntry(cfEntry));
        }
        return null;
    });
}

export const pageService = {
    getContentfulPage,
    getContentfulPageDiscount,
};
